import { DialogContent as MuiDialogContent } from '@mui/material';
import { withStyles } from '@mui/styles';

const StepperDialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

export default StepperDialogContent;
